import { UseFormReturn } from 'react-hook-form'

import { CustomFormQuestion } from 'components/tools/CustomForm/types'

type Params = {
  formMethods: UseFormReturn<any>
  questions: CustomFormQuestion[]
}

export default function setSolicitacaoDeGratificacaoPorTitulacaoEspecializacao(params: Params): CustomFormQuestion[] {
  const { questions } = params
  const visibleDependent2 = false
  const visibleDependent3 = false
  const visibleDependent4 = false
  const visibleDependent5 = false

  const filteredQuestions = questions.filter((question) => {
    const questionAboutDependent = question.title?.includes('Documento')
    const match = question.title?.match(/Documento (\d+) -/)
    let number = null

    if (questionAboutDependent) {
      if (match) {
        number = parseInt(match[1], 10)
      }
    }

    //DOCUMENTO 2
    if (number == 2 && !visibleDependent2) {
      return false
    }

    //DOCUMENTO 3
    if (number == 3 && !visibleDependent3) {
      return false
    }

    //DOCUMENTO 4
    if (number == 4 && !visibleDependent4) {
      return false
    }

    //DOCUMENTO 5
    if (number == 5 && !visibleDependent5) {
      return false
    }

    return true
  })

  return filteredQuestions
}
